import { readonly, ref } from 'vue'
const disableAuthClientSide = import.meta.env.VITE_DISABLE_AUTH_CLIENT_SIDE === 'true'
const isAuthenticated = ref(disableAuthClientSide)
const sessionInfo = ref({ username: '', picUrl: '', sub: '' })

const checkAuth = () => {
  if (disableAuthClientSide) {
    isAuthenticated.value = true
  } else if (document.cookie && new URLSearchParams(document.cookie).get('userdata')) {
    const sanitizedToken = new URLSearchParams(document.cookie).get('userdata').match(/^s:(.*)\..*$/)[1]
    sessionInfo.value = JSON.parse(sanitizedToken)
    isAuthenticated.value = true
    localStorage.setItem('userid', sessionInfo.value.sub)
  } else {
    isAuthenticated.value = false
  }
}

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.ready.then(() => {
    navigator.serviceWorker.addEventListener('message', (event) => {
      const { type, status } = event.data
      if (type === 'AUTH_ERROR' && (status === 401 || status === 403)) {
        isAuthenticated.value = false
        sessionInfo.value = { username: '', picUrl: '', sub: '' }
      }
    })
  })
}

checkAuth()

export function useAuth () {
  return { isAuthenticated: readonly(isAuthenticated), sessionInfo: readonly(sessionInfo), checkAuth }
}
